"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyCenterThemePartial = exports.PrivacyCenterTextStyles = exports.PrivacyCenterFont = exports.PrivacyCenterFontBasic = exports.PrivacyCenterComponentStyles = exports.PrivacyCenterConfigurableColorPalette = exports.ConfigurableColorPaletteColor = exports.OptionalConfigurableColorPaletteColor = exports.RequiredConfigurableColorPaletteColor = exports.CustomizableText = exports.CustomizableComponent = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const t = __importStar(require("io-ts"));
/**
 * The names of the components that can be provided css overrides
 */
var CustomizableComponent;
(function (CustomizableComponent) {
    /** H1 */
    CustomizableComponent["H1"] = "h1";
    /** H2 */
    CustomizableComponent["H2"] = "h2";
    /** H3 */
    CustomizableComponent["H3"] = "h3";
    /** Body */
    CustomizableComponent["Body"] = "body";
    /** Style the text on the side menu */
    CustomizableComponent["SideMenuText"] = "sideMenuText";
    /** Primary button */
    CustomizableComponent["PrimaryButton"] = "primaryButton";
    /** Secondary button */
    CustomizableComponent["SecondaryButton"] = "secondaryButton";
    /** Email button */
    CustomizableComponent["EmailButton"] = "emailButton";
    /** Email container styles */
    CustomizableComponent["EmailContainer"] = "emailContainer";
    /** Hero image */
    CustomizableComponent["Hero"] = "hero";
    /** Hero background */
    CustomizableComponent["HeroBackground"] = "heroBackground";
    /** Take control confirmation styles */
    CustomizableComponent["TakeControlConfirmation"] = "takeControlConfirmation";
})(CustomizableComponent || (exports.CustomizableComponent = CustomizableComponent = {}));
/**
 * The names of the text fonts
 */
var CustomizableText;
(function (CustomizableText) {
    /** Headers */
    CustomizableText["FontFamilyHeader"] = "fontFamilyHeader";
    /** Body */
    CustomizableText["FontFamilyBody"] = "fontFamilyBody";
})(CustomizableText || (exports.CustomizableText = CustomizableText = {}));
/**
 * The color palette that must be defined
 */
exports.RequiredConfigurableColorPaletteColor = (0, type_utils_1.makeEnum)({
    /**
     * Used everywhere...
     *
     * The primary color chosen by Company X will be applied by default to the following elements of the Privacy Center:
     *  1. **Hero background**
     *  2. **Sidebar navigation background**
     *  3. **Primary CTA (call to action)**
     *  4. **Primary links and active states**
     */
    Primary: 'primary',
    /**
     * Used everywhere...
     *
     * The secondary color chosen by Company X will be applied by default to the following elements of the Privacy Center::
     *   1. **Secondary CTAs**
     *   2. **Secondary links**
     */
    Secondary: 'secondary',
});
/**
 * The optional color pallette colors
 */
exports.OptionalConfigurableColorPaletteColor = (0, type_utils_1.makeEnum)({
    /**
     * The background color will be set by the primary color by default with the ability to change it to secondary color, black or white.
     */
    SidebarNavBg: 'sidebarNavBg',
    /**
     * The hero background color
     */
    HeroBg: 'heroBg',
    /**
     * The background of the widget
     */
    WidgetBg: 'widgetBg',
    // ///////////// //
    // Text Coloring //
    // ///////////// //
    /** The main text color to use when text is shown on an object colored bg */
    TextOnBg: 'textOnBg',
    /** A lighter text color to use when text is shown on an object colored bg */
    TextLightOnBg: 'textLightOnBg',
    /** The main text color to use when text is shown on an object colored primary */
    TextOnPrimary: 'textOnPrimary',
    /** Text on sidebar */
    TextOnSidebar: 'textOnSidebar',
    /** Accent on sidebar */
    AccentOnSidebar: 'accentOnSidebar',
    /** Text to use on hero */
    TextOnHero: 'textOnHero',
    /** Text to use on About Transcend widget */
    TextOnAboutTranscend: 'textOnAboutTranscend',
    /** Used to highlight text */
    Highlight: 'highlight',
    /** The color of the table outline */
    TableOutline: 'tableOutline',
    // //// //
    // Page //
    // //// //
    /** The page's accent background color (used in call-outs and asides) */
    BgAccent: 'bgAccent',
    /** Error color -- something went wrong */
    Error: 'error',
});
/**
 * The color palette that an organization can customize on their privacy center exposed in the default GUI.
 */
exports.ConfigurableColorPaletteColor = (0, type_utils_1.makeEnum)({
    ...exports.RequiredConfigurableColorPaletteColor,
    ...exports.OptionalConfigurableColorPaletteColor,
});
/**
 * The shape of a configurable color palette
 */
exports.PrivacyCenterConfigurableColorPalette = t.intersection([
    t.record((0, type_utils_1.valuesOf)(exports.RequiredConfigurableColorPaletteColor), t.string),
    t.partial((0, type_utils_1.applyEnum)(exports.OptionalConfigurableColorPaletteColor, () => t.string)),
]);
/**
 * Custom CSS for privacy center
 */
exports.PrivacyCenterComponentStyles = t.partial((0, type_utils_1.applyEnum)(CustomizableComponent, () => t.string));
/**
 * A font definition
 */
exports.PrivacyCenterFontBasic = t.type({
    name: t.string,
    url: t.string,
});
/**
 * A font definition
 */
exports.PrivacyCenterFont = t.intersection([
    exports.PrivacyCenterFontBasic,
    t.partial({
        assets: t.array(exports.PrivacyCenterFontBasic),
    }),
]);
exports.PrivacyCenterTextStyles = t.partial((0, type_utils_1.applyEnum)(CustomizableText, () => exports.PrivacyCenterFont));
/**
 * Input for defining a new theme
 */
exports.PrivacyCenterThemePartial = t.intersection([
    t.type({
        /** The display name of the theme */
        name: t.string,
        /** The theme colors */
        colors: exports.PrivacyCenterConfigurableColorPalette,
    }),
    t.partial({
        /** Styles to apply to components */
        componentStyles: exports.PrivacyCenterComponentStyles,
        /** Override styles */
        textStyles: exports.PrivacyCenterTextStyles,
    }),
]);
//# sourceMappingURL=theme.js.map